module.exports = __webpack_public_path__ + "img/aqfh-img-72.e773a888.png";